import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

interface CalculateEnergyCostsMeasure{
    "current_state": {
      "code": string,
      "installation_year": number
    },
    "planned_state": {
      "code": string,
      "cost_estimate": number,
      "isfp": boolean
    }
  }

export interface ESRCalculateEnergyCostsBody{
    "annual_energy_consumption_kWh": number,
    "annual_electricity_consumption_kWh": number,
    "renovation_measures": Partial<{
      "facade_insulation": CalculateEnergyCostsMeasure,
      "roof_insulation": CalculateEnergyCostsMeasure,
      "floor_insulation": CalculateEnergyCostsMeasure,
      "window": CalculateEnergyCostsMeasure,
      "heating_system": {
        "current_state": {
          "code": string,
          "installation_year": number
        },
        "planned_state": {
          "code": string,
          "cost_estimate": number,
          "isfp": boolean
          "natural_refrigerant":boolean,
          "income_bonus": boolean,
          "replacement": boolean,
        }
      },
      "ventilation_system": CalculateEnergyCostsMeasure,
      "solar_thermal": {
        "current_state": {
          "code": string,
          "installation_year": number,
          "roof_pitch": number,
          "orientation": string
        },
        "planned_state": {
          "code": string,
          "cost_estimate": number,
          "roof_pitch": number,
          "orientation": string,
        }
      },
      "photovoltaics": {
        "current_state": {
          "code": string,
          "installation_year": number,
          "annual_yield_kWh": number,
          "battery_storage": boolean
        },
        "planned_state": {
          "code": string,
          "cost_estimate": number,
          "natural_refrigerant":boolean,
          "battery_storage": boolean
        }
      }
    }>,
    "energy_costs": {
      "current": number,
      "planned": number
    }
  }

export interface ESRCalculateEnergyCostsResponse {
    "annual_energy_consumption_kwh_default": number,
    "annual_pv_production_kwh_default": number,
    "annual_heating_costs_default": number,
    "energy_efficiency_class_default": string,
    "co2_emission_default": number,
    "annual_energy_consumption_kwh_current": number,
    "annual_pv_production_kwh_current": number,
    "annual_heating_costs_current": number,
    "energy_efficiency_class_current": string,
    "co2_emission_current": number,
    "annual_energy_consumption_kwh_planned": number,
    "annual_pv_production_kwh_planned": number,
    "annual_heating_costs_planned": number,
    "energy_efficiency_class_planned": string,
    "co2_emission_planned": number,
    "annual_possible_savings": number,
    "monthly_possible_savings": number,
    "energy_efficiency_class_default_level"?: number,
    "energy_efficiency_class_adjusted_level"?: number,
    "energy_efficiency_class_planned_level"?: number
  }

export const ESRCalculateEnergyCostsResponseSchema : SchemaObject = {
    "annual_energy_consumption_kwh_default": "number",
    "annual_pv_production_kwh_default": "number",
    "annual_heating_costs_default": "number",
    "energy_efficiency_class_default": "string",
    "co2_emission_default": "number",
    "annual_energy_consumption_kwh_current": "number",
    "annual_pv_production_kwh_current": "number",
    "annual_heating_costs_current": "number",
    "energy_efficiency_class_current": "string",
    "co2_emission_current": "number",
    "annual_energy_consumption_kwh_planned": "number",
    "annual_pv_production_kwh_planned": "number",
    "annual_heating_costs_planned": "number",
    "energy_efficiency_class_planned": "string",
    "co2_emission_planned": "number",
    "annual_possible_savings": "number",
    "monthly_possible_savings": "number"
  }
  

export class ESRCalculateEnergyCosts extends Request<ESRCalculateEnergyCostsResponse>{
    override method : TRequestMethod = "POST";
    override responseSchema : Schema = ESRCalculateEnergyCostsResponseSchema;

    constructor (
        public sessionToken: string,
        public body: ESRCalculateEnergyCostsBody){
        super();
    }

    override json(): string {
      return JSON.stringify(this.body);
    }

    override route() : string{
        return `${BASEURL}/calculate_energy_costs?sessionToken=${this.sessionToken}`;
    }
}